import { createContext, useContext } from 'react';
import type { PublicSettings } from '@avh/shared';

/** Öffentliche Vereinsdaten (Impressum, Kontakt). `null` solange sie laden. */
export const SettingsContext = createContext<PublicSettings | null | undefined>(undefined);

export function usePublicSettings(): PublicSettings | null {
  const value = useContext(SettingsContext);
  if (value === undefined) {
    throw new Error('usePublicSettings must be used inside <SettingsProvider>');
  }
  return value;
}
